<!-- css -->
<style type="text/css" scoped>
.header {
  height: 128px;
  display: flex;
  flex-direction: column;
}

.header-userInfo {
  height: 48px;
  background-color: #FAFAFA;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.user-icon {
  height: 36px;
  border-radius: 18px;
  margin-left: 16px;
}

.user-info {
  margin-left: 10px;
  display: flex;
  flex-direction: column;
}

.user-info-name {
  color: #333333;
  font-size: 14px;
}

.user-info-coin {
  margin-top: 4px;
  color: #EEB862;
  font-size: 12px;
}

.user-topup {
  margin-right: 6px;
  height: 40px;
  width: 40px;
}

.header-search-field {
  margin-top: 20px;
  height: 40px;
  background-color: #EFEFEF;
  border-radius: 5px;
  margin-left: 16px;
  margin-right: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
}

.header-search-content {
  height: 24px;
  flex-grow: 1;
  margin-right: 6px;
  margin-left: 6px;
  border-style: none;
  font-size: 14px;
  color: #333333;
  background-color: #EFEFEF;
}

.header-search-clear {
  height: 24px;
  margin-right: 6px;
}

.header-divider {
  height: 1px;
  background-color: #EFEFEF;
  margin-top: 20px;
}

</style>
<!-- html-->
<template>
  <div class="header">
    <!-- user info -->
    <div class="header-userInfo">
      <!-- icon -->
      <img class="user-icon" @error="handleImgError" :src="userInfo.portrait">
      <!-- info -->
      <div class="user-info">
        <!-- nickname -->
        <span class="user-info-name">{{userInfo.name}}</span>
        <!-- coins -->
        <span class="user-info-coin">{{userInfo.coin}}钢镚</span>
      </div>
      <!-- spring -->
      <div class="spring"></div>
      <!-- topUp -->
      <div @click="handleTopUp">
        <img class="user-topup" src="../../assets/header_topUp.png">
      </div>
    </div>
    <!-- search -->
    <div class="header-search-field">
      <input class="header-search-content" type="text" name="search" :placeholder="placeholder" @input="change" v-model="searchVal" @keydown="keydown($event)">
      <img class="header-search-clear" src="../../assets/search_clear.png" @click="clear">
    </div>
    <!-- divider -->
    <div class="header-divider"></div>
  </div>
</template>
<!-- javascript -->
<script type="text/javascript">
import Storage from '../../common/storage'
import Tool from '../../common/tool'
export default {
  name: 'header',
  data: function(argument) {
    return {
      userInfo: {
        name: 'XXXX',
        coin: 0,
        portrait: require('../../assets/avatar_default.png')
      },
      searchVal: '',
      placeholder: '请输入小区名（查询一次仅需1钢镚）'
    }
  },
  mounted: function(argument) {
    this.loadLocalUserInfo()
    this.updateUI()
  },
  methods: {
    // 更新UI
    updateUI: function(argument) {
      let type = Tool.query('type')
      if (parseInt(type) === 0) {
        this.placeholder = '请输入小区名（查询一次仅需1钢镚）'
      } else if (parseInt(type) === 1) {
        this.placeholder = '请输入商圈名'
      } else if (parseInt(type) === 2) {
        this.placeholder = '请输入区县名'
      }
    },
    // 加载本地用户信息
    loadLocalUserInfo: function(argument) {
      if (Storage.queryItem('userInfo') === null) {
        return
      }
      var userInfo = JSON.parse(Storage.queryItem('userInfo'))
      var coin = parseInt(Storage.queryItem('coin'))
      this.userInfo = {
        name: userInfo.name,
        coin: coin,
        portrait: userInfo.portrait
      }
    },
    // 更新用户信息
    updateUserInfo: function(val) {
      this.userInfo = val
    },
    // 充值
    handleTopUp: function(argument) {
      this.$emit('topup')
    },
    // change
    change: function(argument) {
      this.$emit('change', this.searchVal)
    },
    // 清除
    clear: function(argument) {
      if (!this.searchVal || this.searchVal.length === 0) {
        return
      }
      this.searchVal = ''
      this.$emit('clear')
    },
    // img error
    handleImgError: function(evt) {
      var img = event.srcElement
      img.src = require('../../assets/avatar_default.png')
      img.onerror = null
    },
    keydown: function(evt) {
      if (parseInt(evt.keyCode) === 13) { // return key
        document.activeElement.blur()
        this.search()
      }
    },
    search: function(argument) {
      if (this.searchVal && this.searchVal.length > 0) {
        this.$emit('search', this.searchVal)
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// NIMianHead.vue?258fe414